module.exports = __webpack_public_path__ + "img/closeon.0866a12f.svg";